<template>
	<div class="scroll" style="height:calc(100vh - 100px);">

		<dialogue
			:title="'Add Box'"
			:paragraph="box_dialogue_text"
			:button_names="['Yes','No']"
			:show="box_dialogue"
			v-on:dialogue="addBox"
			v-on:cancel="cancelBox"
		></dialogue>

		<checkitem
			:show=checkOpen
			:isIn=checkIsIn
			:itemId=term
			v-on:cancel="closeCheck"
			v-on:dialogue="checkItem"
		></checkitem>

		<layout-3 :id=pageid :term=term :width=5 :height=3 :key=updateKey></layout-3>

		<hr style="margin-left:25px;margin-right:25px;"/>

		<layout-1 :table_name="'Transactions'"
		:id=pageid3 :searchbar=false :collapseable="true" :height_limit="true"
		:navbar=false :select_reroute=false :term=term></layout-1>

		<hr style="margin-left:25px;margin-right:25px;"/>

		<div style="padding:16px;">
			<inventorypics :inventorypic_id="term" :imageCount=99 :height="'300px'" style="width:100%"></inventorypics>
		</div>

		<div class="nav-bar">
			<div>
				<button v-for="(item, index) in nav_items" v-if="perms.includes(nav_item_perms[index])" v-on:click="button(item)">{{item}}</button>
				<button v-on:click="check(false)">Check Out</button>
				<button v-on:click="check(true)">Check In</button>
			</div>
		</div>
	</div>
</template>

<script>
import {PAGES} from './../../../constants.js'
import api from '@/api'
import router from '@/router/index'
export default {
    props: {
		term: ''
    },
	data(){
		return{
			perms:[],
			pageid:PAGES.VIEW_INVENTORY_PAGE,
			pageid2:PAGES.ADD_NEW_BOX_PAGE,
			pageid3:PAGES.VIEW_INVENTORY_TRANSACTIONS_PAGE,
			nav_items:['Inventory List', 'Edit Inventory List', 'Scan Item', 'Edit'],
			nav_item_perms:['88','88','89','89'],
			checkOpen:false,
			checkIsIn:false,
			updateKey:0,
			box_dialogue:false,
			box_dialog_text:'',
			box_id:null,
		}
	},
	async created () {
		this.perms = api.getPerms();
		this.openBoxDialogue('1001');
	},
	methods:{
		async button (name){
			api.postData(
				{
					type:"button",
					data:{
						pageid:this.pageid,
						buttonname:name,
					}
				}
			).then((res) => {
				if(res.data.data.to!=null) {
					if(res.data.data.useterm) {
						router.push('/'+res.data.data.to+'?q='+this.term);
					} else {
						router.push('/'+res.data.data.to);
					}
				}
			});
		},

		closeCheck(){
			this.checkOpen=false;
		},
		check(isIn){
			this.checkIsIn=isIn;
			this.checkOpen=true;
		},
		checkItem(itemId){
			this.openBoxDialogue(itemId);
			this.updateKey++;
		},

		openBoxDialogue(itemId){
			api.postData(
				{
					type:"search",
					data:{
						pageid:this.pageid2,
						itemId:itemId,
					}
				}
			).then((res) => {
				var boxId = res.data.data.column_data[0][0]
				if(boxId!="null") {
					this.box_id = boxId;
					this.box_dialogue_text = "Box "+boxId+" does not exist.\nCreate a new box?";
					this.box_dialogue = true;
				}
			});
		},
		cancelBox(){
			this.box_dialogue = false;
		},
		addBox(buttonName){
			if(buttonName=="Yes"){
				api.postData(
					{
						type:"insert",
						data:{
							pageid:this.pageid2,
							boxId:this.box_id,
						}
					}
				);
			}
		},
	}
}
</script>



// WEBPACK FOOTER //
// src/components/view/View_Inventory.vue